module.exports = __webpack_public_path__ + "audio-279234413f0a.m4a";